const permissions = {
  GROUP_READ: "group_read",
  GROUP_EDIT: "group_edit",
  GROUP_DELETE: "group_delete",
  CUSTOMERINVITATION_CREATE: "customerinvitation_create",
  GROUPINVITATION_CREATE: "groupinvitation_create",
  TENANTINVITATION_CREATE: "tenantinvitation_create",
  RESENDINVITATION_READ: "resendinvitation_read",
  TENANTUSER_DELETE: "tenantuser_delete",
  TENANTUSER_READ: "tenantuser_read",
  GROUPUSER_DELETE: "groupuser_delete",
  GROUPUSER_READ: "groupuser_read",
  CUSTOMERUSER_DELETE: "customeruser_delete",
  CUSTOMERUSER_READ: "customeruser_read",
  USER_EDIT: "user_edit",
  USER_READ: "user_read",
  WEATHERFORECAST_READ: "weatherforecast_read",
  WEATHERFORECAST_CREATE: "weatherforecast_create",
  WEATHERFORECAST_EDIT: "weatherforecast_edit",
  WEATHERFORECAST_DELETE: "weatherforecast_delete",
  TEST123: "test123",
  DOCUMENTS_READ: "documents_read",
  DOCUMENTS_CREATE: "documents_create",
  DOCUMENTS_EDIT: "documents_edit",
  DOCUMENTS_DELETE: "documents_delete",
  DOCUMENTSSIGNING_READ: "documentssigning_read",
  DOCUMENTSSIGNING_CREATE: "documentssigning_create",
  DOCUMENTSSIGNING_ONBEHALFOF: "documentssigning_onbehalfof",
  DOCUMENTSSIGNING_DELETE: "documentssigning_delete",
  CUSTOMERCONFIGURATION_READ: "customerconfiguration_read",
  CUSTOMERCONFIGURATION_CREATE: "customerconfiguration_create",
  CUSTOMERCONFIGURATION_DELETE: "customerconfiguration_delete",
  EQUIPMENTCONFIGURATIONS_READ: "equipmentconfigurations_read",
  EQUIPMENTCONFIGURATIONS_CREATE: "equipmentconfigurations_create",
  EQUIPMENTCONFIGURATIONS_DELETE: "equipmentconfigurations_delete",
  EVENTSCONFIGURATIONS_READ: "eventsconfigurations_read",
  EVENTSCONFIGURATIONS_CREATE: "eventsconfigurations_create",
  EVENTSCONFIGURATIONS_DELETE: "eventsconfigurations_delete",
  METADATA_READ: "metadata_read",
  REQUIREMENTTYPES_READ: "requirementtypes_read",
  REQUIREMENTTYPES_CREATE: "requirementtypes_create",
  REQUIREMENTTYPES_DELETE: "requirementtypes_delete",
  REQUIREMENTVALIDATIONRESULTS_READ: "requirementvalidationresults_read",
  REQUIREMENTVALIDATIONRESULTS_CREATE: "requirementvalidationresults_create",
  REQUIREMENTVALIDATIONRESULTS_EDIT: "requirementvalidationresults_edit",
  REQUIREMENTVALIDATIONRESULTS_DELETE: "requirementvalidationresults_delete",
  RULECONFIGURATIONS_READ: "ruleconfigurations_read",
  RULECONFIGURATIONS_CREATE: "ruleconfigurations_create",
  RULECONFIGURATIONS_DELETE: "ruleconfigurations_delete",
  RULEEVALUATOR_CREATE: "ruleevaluator_create",
  RULEGROUPS_READ: "rulegroups_read",
  RULEGROUPS_CREATE: "rulegroups_create",
  RULEGROUPS_DELETE: "rulegroups_delete",
  TENANTCONFIGURATIONS_READ: "tenantconfigurations_read",
  TENANTCONFIGURATIONS_CREATE: "tenantconfigurations_create",
  TENANTCONFIGURATIONS_DELETE: "tenantconfigurations_delete",
  CUSTOMER_READ: "customer_read",
  CUSTOMER_CREATE: "customer_create",
  CUSTOMER_EDIT: "customer_edit",
  CUSTOMER_DELETE: "customer_delete",
  TENANT_READ: "tenant_read",
  TENANT_CREATE: "tenant_create",
  TENANT_DELETE: "tenant_delete",
  CUSTOMERTENANT_READ: "customertenant_read",
  TENANTDETAILS_READ: "tenantdetails_read",
  TENANTDETAILS_CREATE: "tenantdetails_create",
  TENANTDETAILS_EDIT: "tenantdetails_edit",
  TENANTDETAILS_DELETE: "tenantdetails_delete",
  DEFAULTROLES_CREATE: "defaultroles_create",
  DEFAULTROLES_READ: "defaultroles_read",
  DEFAULTROLES_DELETE: "defaultroles_delete",
  DEFAULTUSERS_CREATE: "defaultusers_create",
  DEFAULTUSERS_READ: "defaultusers_read",
  DEFAULTUSERS_DELETE: "defaultusers_delete",
  CLIENTIP_READ: "clientip_read",
  CLIENTIP_CREATE: "clientip_create",
  CLIENTIP_DELETE: "clientip_delete",
  ROLEPERMISSION_READ: "rolepermission_read",
  ROLEPERMISSION_CREATE: "rolepermission_create",
  ROLEPERMISSION_EDIT: "rolepermission_edit",
  ROLEPERMISSION_DELETE: "rolepermission_delete",
  APPLICATIONPERMISSION_READ: "applicationpermission_read",
  CONTACT_READ: "contact_read",
  CONTACT_CREATE: "contact_create",
  CONTACT_EDIT: "contact_edit",
  CONTACT_DELETE: "contact_delete",
  ELEMENTNOTES_READ: "elementnotes_read",
  EQUIPMENT_READ: "equipment_read",
  EQUIPMENT_CREATE: "equipment_create",
  EQUIPMENT_DELETE: "equipment_delete",
  EQUIPMENT_STATUS_EDIT: "equipment_status_edit",
  EVENTS_READ: "events_read",
  EVENTS_CREATE: "events_create",
  EVENTS_EDIT: "events_edit",
  EVENTS_DELETE: "events_delete",
  ELEMENTTREE_READ: "elementtree_read",
  ELEMENTTREE_CREATE: "elementtree_create",
  ELEMENTTREE_EDIT: "elementtree_edit",
  ELEMENTTREE_DELETE: "elementtree_delete",
  IMAGES_READ: "images_read",
  IMAGES_CREATE: "images_create",
  IMAGES_DELETE: "images_delete",
  MODELCONFIGURATION_READ: "modelconfiguration_read",
  MODELCONFIGURATION_CREATE: "modelconfiguration_create",
  MODELCONFIGURATION_DELETE: "modelconfiguration_delete",
  OBJECT_READ: "object_read",
  MEMBER_READ: "member_read",
  MEMBER_CREATE: "member_create",
  MEMBER_EDIT: "member_edit",
  MEMBER_DELETE: "member_delete",
  SERVICEACCESSTYPE_READ: "serviceaccesstype_read",
  SERVICEACCESSTYPE_CREATE: "serviceaccesstype_create",
  SERVICEACCESSTYPE_EDIT: "serviceaccesstype_edit",
  SERVICEACCESSTYPE_DELETE: "serviceaccesstype_delete",
  SERVICELIST_READ: "servicelist_read",
  SERVICELIST_CREATE: "servicelist_create",
  SERVICELIST_DELETE: "servicelist_delete",
  CONNECTOR_READ: "connector_read",
  CONNECTOR_CREATE: "connector_create",
  CONNECTOR_EDIT: "connector_edit",
  CONNECTOR_DELETE: "connector_delete",
  ELEMENTAVAILABILITY_READ: "elementavailability_read",
  ELEMENTAVAILABILITY_CREATE: "elementavailability_create",
  ELEMENTAVAILABILITY_DELETE: "elementavailability_delete",
  ELEMENTGROUPAVAILABILITY_READ: "elementgroupavailability_read",
  ELEMENTGROUPAVAILABILITY_CREATE: "elementgroupavailability_create",
  ELEMENTGROUPAVAILABILITY_DELETE: "elementgroupavailability_delete",
  MEMBERAVAILABILITY_READ: "memberavailability_read",
  MEMBERAVAILABILITY_CREATE: "memberavailability_create",
  MEMBERAVAILABILITY_DELETE: "memberavailability_delete",
  AVAILABILITY_READ: "availability_read",
  AVAILABILITY_CREATE: "availability_create",
  AVAILABILITY_DELETE: "availability_delete",
  AMENITYACTIVITY_READ: "amenityactivity_read",
  SCHEDULE_APP: "schedule_app",
  SCHEDULE_READ: "schedule_read",
  SCHEDULE_CREATE: "schedule_create",
  SCHEDULE_EDIT: "schedule_edit",
  SCHEDULE_DELETE: "schedule_delete",
  TENANTINVITATION_READ: "tenantinvitation_read",
  DOCUMENTSSIGNING_EDIT: "documentssigning_edit",
  EQUIPMENTGROUPCONFIGURATIONS_READ: "equipmentgroupconfigurations_read",
  EQUIPMENTGROUPCONFIGURATIONS_CREATE: "equipmentgroupconfigurations_create",
  EQUIPMENTGROUPCONFIGURATIONS_DELETE: "equipmentgroupconfigurations_delete",
  REQUIREMENTTYPES_EDIT: "requirementtypes_edit",
  RULECONFIGURATIONS_EDIT: "ruleconfigurations_edit",
  RULEGROUPS_EDIT: "rulegroups_edit",
  EQUIPMENT_EDIT: "equipment_edit",
  EQUIPMENTGROUP_READ: "equipmentgroup_read",
  EQUIPMENTGROUP_CREATE: "equipmentgroup_create",
  EQUIPMENTGROUP_EDIT: "equipmentgroup_edit",
  EQUIPMENTGROUP_DELETE: "equipmentgroup_delete",
  MEMBERUSAGE_READ: "memberusage_read",
  EVENTSUSAGE_READ: "eventsusage_read",
  LEGACYREPORTS_READ: "legacyreports_read",
  EQUIPMENTACTIVITY_READ: "equipmentactivity_read",
  EQUIPMENTUSAGE_READ: "equipmentusage_read",
  MAINTENANCE_READ: "maintenance_read",
  PROGRESSION_READ: "progression_read",
  PROGRESSION_CREATE: "progression_create",
  PROGRESSION_EDIT: "progression_edit",
  PROGRESSION_DELETE: "progression_delete",
  EQUIPMENTHISTORY_READ: "equipmenthistory_read",
  EQUIPMENTHISTORY_CREATE: "equipmenthistory_create",
  APIM_READ: "apim_read",
  APIM_CREATE: "apim_create",
  APIM_EDIT: "apim_edit",
  APIM_DELETE: "apim_delete",
  APIMCONFIG_READ: "apimconfig_read",
  APIMCONFIG_CREATE: "apimconfig_create",
  APIMCONFIG_EDIT: "apimconfig_edit",
  APIMCONFIG_DELETE: "apimconfig_delete",
  APICLIENT_READ: "apiclient_read",
  APICLIENT_CREATE: "apiclient_create",
  APICLIENT_DELETE: "apiclient_delete",
  CONNECTORS_READ: "connectors_read",
  CONNECTORS_CREATE: "connectors_create",
  NOTIFICATION_READ: "notification_read",
  NOTIFICATION_CREATE: "notification_create",
  NOTIFICATION_EDIT: "notification_edit",
  NOTIFICATION_DELETE: "notification_delete",
  REPORTING_APP: "reporting_app",
  REPORTING_READ: "reporting_read",
  REPORTING_CREATE: "reporting_create",
  SCHEDULEHISTORY_READ: "schedulehistory_read",
  ROLES_EDIT: "roles_edit",
  ROLES_DELETE: "roles_delete",
  MONITOR_READ: "monitor_read",
  MONITOR_CREATE: "monitor_create",
  MONITOR_DELETE: "monitor_delete",
  MONITOR_SETTINGSREAD: "monitorsettings_read",
  MONITOR_SETTINGSEDIT: "monitorsettings_edit",
  MONITOR_SETTINGSDELETE: "monitorsettings_delete",
};

export default permissions;
